import { render, staticRenderFns } from "./VaCountBadge.vue?vue&type=template&id=2cf173a2&"
import script from "./VaCountBadge.vue?vue&type=script&lang=js&"
export * from "./VaCountBadge.vue?vue&type=script&lang=js&"
import style0 from "./VaCountBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports